/* esm.sh - micromark-extension-gfm@3.0.0 */
export * from "/*micromark-extension-gfm@3.0.0/esnext/micromark-extension-gfm.mjs";
